"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LADORIAN_PROVIDER = void 0;
exports.LADORIAN_PROVIDER = "ladorian";
